import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Groups from './Groups';
import ClientsTable from './ClientsTable';
import GroupDetail from './GroupDetail';
import AddToGroup from './AddToGroup/AddToGroup';
import AddToGroupModal from './AddToGroup/AddToGroupModal';

import './ClientsWithGroups.css';
import { carsStore } from '../../../../stores';

@inject('filterStore', 'translationsStore', 'groupsStore', 'commonStore', 'carsStore')
@observer
export default class ClientsWithGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleAddToGroup: false,
      selectedRows: [],
      selectedGroup: 'allgroups'
    };
    this.AddToGroupModalRef = React.createRef();
  }

  componentDidMount = () => {
    this.AddToGroupModalInstance = this.AddToGroupModalRef.current.wrappedInstance;
  };

  componentWillUnmount() {
    this.props.filterStore.reset();
  }

  onSelectedRowsChange = selectedRows => {
    this.setState({ visibleAddToGroup: selectedRows.length !== 0, selectedRows });
  };

  onChooseGroup = () => {
    this.AddToGroupModalInstance.show();
  };

  handleAddSelectedRowsToGroup = groupId => {
    const { translationsStore, commonStore, groupsStore } = this.props;
    const { selectedRows } = this.state;
    const selectedIds = selectedRows.reduce((acc, row) => {
      acc.push(row.id);
      return acc;
    }, []);

    this.AddToGroupModalInstance.hide();
    commonStore.setLoadingMessage(translationsStore.translate('groupsManager.assignToGroup.loadingVehiclesAndGroups'));
    commonStore.setLoading(true);
    groupsStore.addVehicles(groupId, ...selectedIds).then(response => {
      // this.setState({ selectedRows: [] });
      commonStore.setLoading(false);
    });
  };

  onGroupChange = groupId => {
    console.log(`passo a id gruppo=${groupId} in ClientsWithGroup`);
    this.resetTableView();
  };

  resetTableView = () => {
    this.setState({ selectedRows: [], visibleAddToGroup: false });
  };

  apply = () => {
    this.props.filterStore.apply();
  };

  render() {
    const { cars, groups, filterStore } = this.props;
    const { visibleAddToGroup, selectedRows, selectedGroup } = this.state;

    return (
      <div className="ClientsWithGroups">
        <React.Fragment>
          <Groups
            cars={cars}
            groups={groups}
            onSelect={({ selected, group }) => {
              this.setState({ selectedGroup: selected, groupData: null });
              filterStore.remove('groupFilter');
              delete(carsStore.appliedFilters.groupId);
              if (!!group) {
                filterStore.add('groupFilter.group_' + group.id, car => car.groupId === group.id);
                carsStore.appliedFilters.groupId = group.id;
              }
              if (selected === 'orphans') {
                filterStore.add('groupFilter.group_orphans', car => car.groupId === null);
                carsStore.appliedFilters.groupId = null;
              }
              carsStore.applyFilters();
              //filterStore.apply();
            }}
            selected={selectedGroup}
            onGroupChange={this.onGroupChange}
          />
          <AddToGroup visible={visibleAddToGroup} onChooseGroup={this.onChooseGroup} />
          <div style={{ display: 'flex', flexDirection: 'column' }} className="content">
            {!!groups && <GroupDetail visible={!!groups.find(g => g.id === selectedGroup)} group={groups.find(g => g.id === selectedGroup)} />}
            <ClientsTable
              cars={cars}
              group={!!groups ? groups.find(g => g.id === selectedGroup) : undefined}
              selectedRows={selectedRows}
              onSelectedRowsChange={this.onSelectedRowsChange}
            />
            <AddToGroupModal
              ref={this.AddToGroupModalRef}
              width={560}
              group={!!groups ? groups.find(g => g.id === selectedGroup) : undefined}
              selectedRows={selectedRows}
              handleAddSelectedRowsToGroup={this.handleAddSelectedRowsToGroup}
            />
          </div>
        </React.Fragment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/ClientsWithGroups.js